/**
 * Recharts can't read CSS variables, so chart fills are resolved to the same
 * values the design tokens declare in index.css (mirrors expansion's
 * chartColors.ts). Keep in lockstep with index.css.
 */
import type { DealHealthBand } from "../api";

export const DEAL_HEALTH_COLORS: Record<DealHealthBand, string> = {
  healthy: "hsl(152 60% 36%)", // --status-success
  at_risk: "hsl(38 92% 50%)", // --status-warning
  stalled: "hsl(0 84% 60%)", // --status-danger
};

export const DEAL_HEALTH_GRID = "hsl(0 0% 88%)";
export const DEAL_HEALTH_RADAR = "#0994f2"; // --cinch-brand

export const BAND_LABEL: Record<DealHealthBand, string> = {
  healthy: "Healthy",
  at_risk: "At Risk",
  stalled: "Stalled",
};

/** Short pipeline labels for chips/columns. The mart's name for the
 *  upsells pipeline is "Customer Success" (formerly Upsells & Replacements). */
export const PIPELINE_SHORT: Record<string, string> = {
  "Sales Pipeline": "Sales",
  "Customer Success": "Upsells (CS)",
  Partnerships: "Partners",
};

export function pipelineShort(name: string | null | undefined): string {
  if (!name) return "—";
  return PIPELINE_SHORT[name] ?? name;
}
